angular.module('b2bLoginApp.services').factory('Contact', ['$resource',
    function($resource){
        return $resource('contact.json');
    }]);
